import React from 'react'
import NavigationItem from './NavigationItem'

export default function NavigationItemList({ steps, title, application }) {   
   return (
      <div className="navigation-section-list">
         <h4 className="application-step-title">{ title }</h4>
         <div className="resinous-application-steps">
            <ul className="list-unstyled application-step-list">
               {
               steps ? (
                  steps.map((step, index) => {
                     return (
                        <NavigationItem key={ step } step={ step } order={ (application && application.toLowerCase().indexOf('resinous') > -1) ? index : index+1 } />
                     )
                  })
               ) : ( null )
               }
            </ul>
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/NavigationItemList.js